import React from 'react';

interface Props {
  label?: string;
  isMandatory?: boolean;
}

const InputWrapperLabel: React.FC<Props> = ({ label, isMandatory }) => {
  return (
    <p className="input-wrapper__label" style={{ color: label === '' ? 'transparent' : '' }}>
      {label} {isMandatory && <span className="input-wrapper__label--mandatory">*</span>}
    </p>
  );
};

export default InputWrapperLabel;
